import { render, staticRenderFns } from "./TepGraficaTurnosFinalizadosInternos.vue?vue&type=template&id=08d22900"
import script from "./TepGraficaTurnosFinalizadosInternos.vue?vue&type=script&lang=js"
export * from "./TepGraficaTurnosFinalizadosInternos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports